import './index.css';

function Button({
  text,
  type = 'button',
  block,
  color,
  onClick,
  renderIcon = () => {},
  Icon,
  reference
}) {
  let className = '';
  let btnRef;
  if (block) {
    className = `Btn Btn--block`;
  } else {
    className = `Btn`
  }
  if (color) {
    className = `${className} Btn--${color}`;
  }
  if (reference) {
    btnRef = reference;
  }
  return (
    <button
      type={type}
      onClick={onClick}
      className={className}
      ref={btnRef}
    >
      <span className="BtnText">
        {renderIcon && <i className='BtnIcon'>{renderIcon()}</i>}
        {Icon && <div className="BtnIcon"><Icon /></div>}
        {text}
      </span>
    </button>
  );
}

export { Button };
